import { Controller } from "@hotwired/stimulus"

// Hands wheel scroll past an inner scrollbox's edges straight to the page.
// Browsers latch a gesture to the inner scroller even once it's exhausted,
// which forces a second gesture before the page moves; this makes it
// continuous. Attach to the scrolling element itself:
//   data-controller="scroll-chain"
//   data-action="wheel->scroll-chain#chain:!passive"
// Registered non-passive (:!passive) so preventDefault can stop the
// browser's own chaining from double-scrolling on fresh gestures.
// Touch scrolling chains natively, so this handler is wheel-only.
export default class extends Controller {
  chain(event) {
    const el = this.element
    const atTop = el.scrollTop <= 0
    const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1
    // deltaMode 1 = lines (Firefox); normalize to pixels
    const delta = event.deltaY * (event.deltaMode === 1 ? 16 : 1)
    if ((delta < 0 && atTop) || (delta > 0 && atBottom)) {
      event.preventDefault()
      // The page scroller is the layout's <main> on desktop
      // (lg:overflow-y-auto), the window on mobile — find whichever
      // ancestor actually scrolls.
      const parent = this._scrollParent(el.parentElement)
      if (parent) {
        parent.scrollBy(0, delta)
      } else {
        window.scrollBy(0, delta)
      }
    }
  }

  _scrollParent(node) {
    for (let n = node; n; n = n.parentElement) {
      if (n.scrollHeight > n.clientHeight) {
        const overflowY = getComputedStyle(n).overflowY
        if (overflowY === "auto" || overflowY === "scroll") return n
      }
    }
    return null
  }
}
